






import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/menu/Header.vue';
import UsuarioAM from '@/components/employee/useram/UsuarioAM.vue';
// import Footer from '@/components/Footer.vue';

@Component({
  components: {
    UsuarioAM,
  },
})
export default class UsuarioAMView extends Vue {}
